var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m114.997 483.914c-1.933 0-3.882-.373-5.737-1.142-5.606-2.322-9.26-7.792-9.26-13.858v-101.802c-56.352-7.371-100-55.696-100-114.026v-110c0-63.411 51.589-115 115-115h282c63.411 0 115 51.589 115 115v110c0 63.411-51.589 115-115 115h-159.96l-111.434 111.434c-2.869 2.869-6.706 4.394-10.609 4.394z",
    fill: "#ffe645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m397 28.086h-142.014v340h142.014c63.411 0 115-51.589 115-115v-110c0-63.411-51.589-115-115-115z",
    fill: "#ffcf2c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m109.702 138.256c0-6.4 6.799-9.6 13.6-9.6h69.398c6.6 0 9.4 7 9.4 13.4 0 7.4-3.4 13.8-9.4 13.8h-51.799v33.799h30.199c6 0 9.4 5.8 9.4 12.2 0 5.4-2.801 11.8-9.4 11.8h-30.199v51.6c0 6.4-7.801 9.6-15.6 9.6-7.801 0-15.6-3.2-15.6-9.6v-126.999z",
    fill: "#1a82c7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m196.886 262.054c0-.6.201-1.4.4-2.2l37.199-121.998c2.201-7 11.201-10.4 20.4-10.4s18.199 3.4 20.4 10.4l37.398 121.998c.199.8.4 1.6.4 2.2 0 7.4-11.4 12.8-20 12.8-5 0-9-1.6-10.199-5.8l-6.801-25h-42.199l-6.799 25c-1.201 4.2-5.201 5.8-10.201 5.8-8.598 0-19.998-5.4-19.998-12.8zm72.6-42-14.499-53.23-14.7 53.23z",
    fill: "#1a82c7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#125994"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.101 287.053v-11.6c-22.799-2.8-39.398-16.2-39.398-46.6v-52.999c0-34.6 21.398-47.199 48.998-47.199s49.199 12.6 49.199 47.199v52.999c0 30.4-16.799 43.799-39.6 46.6v11.6c0 6.4-4.799 9.6-9.6 9.6-4.799.001-9.599-3.2-9.599-9.6zm27.599-111.198c0-13.6-6.799-19.999-18-19.999-11.199 0-17.799 6.4-17.799 19.999v52.999c0 9.2 2.799 15 8.199 18v-8.8c0-6.6 4.801-9.4 9.6-9.4 4.801 0 9.6 2.8 9.6 9.4v8.8c5.201-3 8.4-8.8 8.4-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.286 137.856c-2.193-6.974-11.136-10.373-20.3-10.398v39.367l14.499 53.23h-14.499v24h21.099l6.801 25c1.199 4.2 5.199 5.8 10.199 5.8 8.6 0 20-5.4 20-12.8 0-.6-.201-1.4-.4-2.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.9f4f2f5e9beb33e6b2fa83edd878e11b.svg";
export { ForwardRef as ReactComponent };